import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SeriesSection from '../components/SeriesSection';
import RoleplayServersSection from '../components/RoleplayServersSection';

const Home = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <h1>{t('hero.title')}</h1>
          <p>{t('hero.subtitle')}</p>
          <div className="hero-actions">
            <a href="https://auth.molecorp.club/client/app/MoleCorpLauncher-win-Setup.exe" className="cta-button cta-download">{t('hero.download')}</a>
            <Link to="/contact" className="cta-button">{t('hero.cta')}</Link>
          </div>
          <p className="hero-note">{t('hero.download_note')}</p>
        </div>
      </section>

      {/* Services Overview */}
      <section className="services">
        <div className="container">
          <h2 className="section-title">{t('services.title')}</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">💻</div>
              <h3>{t('services.web.title')}</h3>
              <p>{t('services.web.description')}</p>
            </div>
            <div className="service-card">
              <div className="service-icon">📱</div>
              <h3>{t('services.mobile.title')}</h3>
              <p>{t('services.mobile.description')}</p>
            </div>
            <div className="service-card">
              <div className="service-icon">👥</div>
              <h3>{t('services.community.title')}</h3>
              <p>{t('services.community.description')}</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🎮</div>
              <h3>{t('services.gaming.title')}</h3>
              <p>{t('services.gaming.description')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Twitch Series Section */}
      <SeriesSection />

      {/* Roleplay Servers Section */}
      <RoleplayServersSection />

      {/* About Preview */}
      <section className="about">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>{t('about.title')}</h2>
              <p>{t('home.about_preview')}</p>
              <p>{t('home.about_preview2')}</p>
              <Link to="/about" className="cta-button">{t('nav.about')}</Link>
            </div>
            <div className="about-image">
              <img src="/images/logo.png" alt="MoleCorp Logo" />
            </div>
          </div>
        </div>
      </section>

      {/* Contact Preview */}
      <section className="contact">
        <div className="container">
          <div className="contact-content">
            <div className="contact-info">
              <h3>{t('home.contact_ready')}</h3>
              <p>{t('home.contact_description')}</p>
              <p><strong>Email:</strong> info@molecorp.club</p>
            </div>
            <div className="contact-email">
              <h3>{t('home.quick_contact')}</h3>
              <p><strong>📧 Email:</strong> <a href="mailto:info@molecorp.club">info@molecorp.club</a></p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
